import React from 'react';
import PropTypes from 'prop-types';

import styles from '../searchV2.scss';

const FilterButton = ({
    children,
    isActive = false,
    onClick,
    disabled = false,
}) => {
    const activeClass = isActive ? styles.searchFilterBtnActive : '';
    const buttonStyles = `${styles.searchFilterBtn} ${activeClass}`;

    return (
        <div className={styles.filterWrapper}>
            <button
                type="button"
                disabled={disabled}
                className={buttonStyles}
                onClick={onClick}
            >
                {children}
            </button>
        </div>
    );
};

FilterButton.propTypes = {
    children: PropTypes.node.isRequired,
    isActive: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

FilterButton.defaultProps = {
    isActive: false,
    disabled: false,
};

export default FilterButton;
